(function () {
    'use strict';

    angular
        .module('initiativeUpdateStatusReviewRoutes')
        .directive('planDeliverableReview', directive);

    directive.$inject = [];

    function directive() {
        return {
            scope: {
                delivAssessment: '=deliverableAssessment',
                initUpdStatusAssessment: '=initiativeUpdateAssessment',
                // readOnly: '@'
            },
            restrict: 'AE',
            templateUrl: require('./planDeliverableReview.tpl.html'),
            controller: ['$scope', '$state', '$stateParams', '$timeout', 'permissionService', 'initiativeUpdateStatusService', 'businessPlanningService', 'pageDirtyService', 'followUpService',
                function ($scope, $state, $stateParams, $timeout, permissionService, initiativeUpdateStatusService, businessPlanningService, pageDirtyService, followUpService) {

                    /**
                           * @property {{
                           *     IsReviewed,
                           *     MilestoneGroup,
                           *     MilestoneGroupID,
                           *     MilestoneGroup.CompletionStatusID,
                           *     PlanInitiativeID,
                           *     AssessmentCompletionStatusID,
                           *     ReviewTargetDate,
                           *     ReviewCompletionStatusID,
                           *     ReviewCompletionStatus: {},
                           *     ReviewComment,
                           *     ReviewFieldConditions_ByCompletionStatusID,
                           * }} delivAssessment
                           */

                    $scope.selectStatus = function (status) {
                        if ($scope.ctxtCtrl.isReadOnly) return;

                        $scope.delivAssessment.ReviewCompletionStatus = status;
                        $scope.delivAssessment.ReviewCompletionStatusID = status.LookupAttributeValueID;

                        if (isInProgress()) {
                            $scope.ctxtCtrl.isInProgress = true;
                        } else if (isCompleted()) {
                            $scope.ctxtCtrl.isCompleted = true;
                        }

                        if (isFieldRequired('ReviewTargetDate') && _.isUndefined($scope.delivAssessment.ReviewTargetDate)) {
                            $scope.delivAssessment.ReviewTargetDate = $scope.delivAssessment.MilestoneGroup.TargetDate;
                        }

                        if (isFieldRequired('ReviewCompletionDate') && _.isUndefined($scope.delivAssessment.ReviewCompletionDate)) {
                            $scope.delivAssessment.ReviewCompletionDate = $scope.delivAssessment.MilestoneGroup.TargetDate;
                        }

                        $scope.setDirty();
                    };

                    // Download Attachments withing followup modals
                    $scope.getDownloadAttachmentUrl = function (attachmentId, delivAssessment) {
                        var planInitId = $scope.delivAssessment.PlanInitiativeID;
                        var planDelivId = $scope.delivAssessment.MilestoneGroupID;
                        delivAssessment = delivAssessment || $scope.delivAssessment;

                        return initiativeUpdateStatusService
                            .getDownloadAttachmentUrl(
                                $stateParams.ItemPersonID,
                                planInitId,
                                planDelivId,
                                delivAssessment.PlanDeliverableAssessmentID,
                                attachmentId);
                    };

                    $scope.reviewDeliverable = function () {
                        $scope.ctxtCtrl.isReviewed = 'True';

                        // Form Invalid
                        if (!$scope.ctxtCtrl.isFormValid) {
                            $scope.ctxtCtrl.isFormInvalidError = true;
                            $timeout(function () {
                                $scope.ctxtCtrl.isFormInvalidError = false;
                            }, 3000);

                            // Require Follow-ups
                            if (areFollowUpsRequired()) {
                                $scope.ctxtCtrl.showRequireFollowUpError = true;
                                $timeout(function () {
                                    $scope.ctxtCtrl.showRequireFollowUpError = false;
                                }, 12500);
                            }

                            return;
                        }

                        $scope.ctxtCtrl.isLoading = true;
                        var requestDone = false,
                            timeoutDone = false;
                        $timeout(function () {
                            if (requestDone) {
                                $scope.ctxtCtrl.isLoading = false;
                            } else {
                                timeoutDone = true;
                            }
                        }, 250);

                        initiativeUpdateStatusService
                            .reviewPlanDeliverable(
                                $scope.initUpdStatusAssessment.PlanInitiativeAssessment,
                                $scope.delivAssessment)
                            .then(function (deliverableAssessment) {
                                $scope.delivAssessment = deliverableAssessment;
                                $scope.ctxtCtrl.isShowSubmitted = $scope.delivAssessment.IsReviewed === 'True';

                                if ($scope.delivAssessment.ReviewTargetDate) {
                                    $scope.delivAssessment.ReviewTargetDate =
                                        moment($scope.delivAssessment.ReviewTargetDate).format();
                                }

                                return initiativeUpdateStatusService
                                    .getAssessmentsToReviewByAssessorAndInitiative($stateParams.ItemPersonID, $scope.delivAssessment.PlanInitiativeID)
                                    .then(function (assmntByInitiative) {

                                        $scope.initUpdStatusAssessment.PlanInitiativeAssessment = assmntByInitiative.PlanInitiativeAssessment;

                                        pageDirtyService.setPageNotDirty();
                                        $scope.ctxtCtrl.isReviewModified = pageDirtyService.isPageDirty();

                                        if (timeoutDone) {
                                            $scope.ctxtCtrl.isLoading = false;
                                        } else {
                                            requestDone = true;
                                        }
                                    });
                            });
                    };

                    $scope.resetAssessment = function () {
                        if ($scope.ctxtCtrl.isReadOnly) return;

                        var skipMarkPageDirty = $scope.delivAssessment.IsReviewed === false;
                        if (skipMarkPageDirty) {
                            pageDirtyService.setPageNotDirty();
                            $scope.ctxtCtrl.isReviewModified = pageDirtyService.isPageDirty();
                        }

                        // TODO: Use back-end solution to properly reset data
                        $scope.delivAssessment.IsReviewed = false;
                        $scope.delivAssessment.ReviewComment = null;
                        $scope.delivAssessment.ReviewCompletionDate = null;
                        $scope.delivAssessment.ReviewCompletionPercentage = 0;
                        $scope.delivAssessment.ReviewCompletionStatusID = null;
                        $scope.delivAssessment.ReviewCompletionStatus = null;
                        $scope.delivAssessment.ReviewTargetDate = null;
                        $scope.initUpdStatusAssessment.PlanInitiativeAssessment.AreAllDeliverablesReviewed = false;
                        $scope.init();
                        $scope.setDirty(skipMarkPageDirty);
                    };

                    $scope.editAssessment = function () {
                        $scope.ctxtCtrl.isShowSubmitted = false;
                        $scope.setDirty();
                    };

                    $scope.setDirty = function (skipMarkPageDirty) {
                        if ($scope.delivAssessment.ReviewCompletionStatusID) {
                            // Check if there are required fields and if they are provided
                            $scope.ctxtCtrl.isFormValid = areAllFieldsValid();
                        } else {
                            $scope.ctxtCtrl.isShowActions = false;
                        }
                        if (!$scope.ctxtCtrl.isReviewModified && !(_.isBoolean(skipMarkPageDirty) && skipMarkPageDirty)) {
                            pageDirtyService.setPageDirty('Reviews with yellow outline have unsaved changes. Please submit each of them or refresh the page (losing unsaved changes) to continue.');
                            $scope.ctxtCtrl.isReviewModified = pageDirtyService.isPageDirty();
                        }
                    };

                    $scope.completionPercentageChanged = function () {
                        if ($scope.ctxtCtrl.completionPercentage > 0) {
                            $scope.ctxtCtrl.isCompletionPercentageValid = true;
                            $scope.delivAssessment.ReviewCompletionPercentage = $scope.ctxtCtrl.completionPercentage;
                        } else {
                            $scope.ctxtCtrl.isCompletionPercentageValid = false;
                            $scope.delivAssessment.ReviewCompletionPercentage = null;
                        }
                        $scope.setDirty();
                    };

                    $scope.refreshDeliverableReview = function () {
                        init();
                    };

                    $scope.getPlanLookups = function () {
                        businessPlanningService
                            .getPlanLookups()
                            .then(function (planLookups) {
                                $scope.planLookups = planLookups;
                            });
                    };

                    $scope.init = function () {

                        initiativeUpdateStatusService
                            .getFollowUpsByPlanDeliverableID($scope.delivAssessment.PlanInitiativeID,
                                                        $scope.delivAssessment.MilestoneGroupID)
                            .then(function (delivAssContainers) {
                                $scope.delivAssContainers = delivAssContainers;

                                if (_.size(delivAssContainers) > 0) {
                                    $scope.currentFollowUps = delivAssContainers[0].FollowUps;
                                }

                                $scope.ctxtCtrl.isFormValid = areAllFieldsValid();
                            });

                        if (!$scope.delivAssessment.ReviewCompletionPercentage) {
                            $scope.delivAssessment.ReviewCompletionPercentage =
                                $scope.delivAssessment.MilestoneGroup.CompletionPercentage;
                        }

                        $scope.ctxtCtrl = {
                            isReadOnly: false,
                            isCompleted: isCompleted(),
                            isInProgress: isInProgress(),
                            showDatePicker: false,
                            isLoading: false,
                            isShowActions: false,
                            isFormValid: areAllFieldsValid(),
                            completionPercentage: $scope.delivAssessment.ReviewCompletionPercentage,
                            isCompletionPercentageValid: $scope.delivAssessment.ReviewCompletionPercentage > 0,
                            isReviewed: 'False',
                            isFormInvalidError: false,
                            isShowSubmitted: $scope.delivAssessment.IsReviewed === 'True',
                            isReviewModified: false
                        };

                        $scope.delivAssessment.MilestoneGroup.TargetDate =
                            moment($scope.delivAssessment.MilestoneGroup.TargetDate).format();

                        if ($scope.delivAssessment.AssessmentTargetDate) {
                            $scope.delivAssessment.AssessmentTargetDate =
                                moment($scope.delivAssessment.AssessmentTargetDate).format();
                        }

                        if ($scope.delivAssessment.ReviewTargetDate) {
                            $scope.delivAssessment.ReviewTargetDate =
                                moment($scope.delivAssessment.ReviewTargetDate).format();
                        }

                        if (_.isUndefined($scope.initUpdStatusAssessment)) return;
                        if (_.isUndefined($scope.initUpdStatusAssessment.PlanInitiativeAssessment)) return;

                        var hasPermission = permissionService.hasPermission('GRCInitiativeUpdateStatusManagement', 'PlanInitiative', 'ReviewAssessment');

                        $scope.ctxtCtrl.isReadOnly = $scope.delivAssessment.IsReadOnly ||
                            !(hasPermission && $scope.initUpdStatusAssessment.PlanInitiativeAssessment.IsLocked);
                    };

                    // View FollowUps
                    $scope.viewFollowUps = function () {
                        var modalScope = followUpService.openFollowUpsModal(null,
                                                                            $scope.delivAssessment,
                                                                            $scope.currentFollowUps,
                                                                            $scope.delivAssContainers,
                                                                            $scope.getDownloadAttachmentUrl);

                        modalScope.submitFollowUp = function (followUp) {
                            return initiativeUpdateStatusService
                                        .createPlanDeliverableReviewFollowUp($scope.delivAssessment.PlanInitiativeID,
                                                                             $scope.delivAssessment.MilestoneGroupID,
                                                                             $scope.delivAssessment.PlanDeliverableAssessmentID,
                                                                             followUp)
                                        .then(function (assessmentContainer) {
                                            var newFollowUp = assessmentContainer.FollowUps[0];
                                            modalScope.currentFollowUps.unshift(newFollowUp);
                                            $scope.currentFollowUps = modalScope.currentFollowUps;
                                            $scope.setDirty();
                                        });
                        };
                    };

                    // Are FollowUps Required
                    function areFollowUpsRequired() {
                        if ($scope.delivAssessment.ReviewCompletionStatusID === 120) return false; // NoIssue
                        if ($scope.delivAssessment.ReviewCompletionStatusID === 123) return false; // NotStarted
                        if ($scope.delivAssessment.ReviewCompletionStatusID === 119) return false; // Completed

                        var areFollowUpsByReviewerPresent =
                                _.chain($scope.currentFollowUps)
                                 .filter({ UserIsReviewer: true })
                                 .some(function (followUp) {
                                     if (followUp.Comment) return true;

                                     return _.size(followUp.Attachments) > 0;
                                 })
                                 .value();

                        return !areFollowUpsByReviewerPresent;
                    }

                    function areAllFieldsValid() {
                        if (!$scope.delivAssessment.ReviewCompletionStatusID) return false;

                        var conditions = $scope.delivAssessment.ReviewFieldConditions_ByCompletionStatusID,
                            statusID = $scope.delivAssessment.ReviewCompletionStatusID;
                        for (var attribute in conditions[statusID]) {
                            if (conditions[statusID].hasOwnProperty(attribute)
                                && conditions[statusID][attribute].required
                                && conditions[statusID][attribute].required === 'true'
                                && !$scope.delivAssessment[attribute]) {
                                return false;
                            }
                        }

                        return !areFollowUpsRequired();
                    }

                    // Is Field Required?
                    function isFieldRequired(fieldName) {
                        if (_.isUndefined(fieldName)) return false;
                        if (_.isUndefined($scope.delivAssessment.ReviewFieldConditions_ByCompletionStatusID)) return false;

                        var conditionsByCompStatusID = $scope.delivAssessment.ReviewFieldConditions_ByCompletionStatusID;
                        var compStatusID = $scope.delivAssessment.ReviewCompletionStatusID;
                        var fieldConditions = conditionsByCompStatusID[compStatusID][fieldName];

                        if (_.isUndefined(fieldConditions)) return false;

                        return fieldConditions['required'];
                    }

                    function isCompleted() {
                        return $scope.delivAssessment.ReviewCompletionStatus && $scope.delivAssessment.ReviewCompletionStatus.Value === 'Completed';
                    }

                    function isInProgress() {
                        if (!$scope.delivAssessment.ReviewCompletionStatus) return false;

                        return $scope.delivAssessment.ReviewCompletionStatus.Value === 'No-Issue'
                            || $scope.delivAssessment.ReviewCompletionStatus.Value === 'Issues-Being-Monitored'
                            || $scope.delivAssessment.ReviewCompletionStatus.Value === 'Issues-To-Address';
                    }

                }],
            link: function (scope, element, attrs) {
                scope.init();
                scope.getPlanLookups();
            }
        };
    }
})();
